import PropTypes from 'prop-types';
import {TextareaAutosize, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import {generalStore} from "../../index";

const LimitedTextField = observer(props => {
    const {modalStore} = useStores();
    const {limit, isTextAreaAutoSize} = props;
    const [originalValue, setOriginalValue] = useState(null);

    useEffect(() => {
        if (!originalValue) {
            setOriginalValue(props.originalValue || '');
        }
    }, [originalValue, props.originalValue]);


    function change(event) {
        if (limit) {
            const newValue = event.target.value;
            if (originalValue.length <= limit && newValue.length > limit) {
                modalStore.showErrorMessage(generalStore.translate('charactersLimitIs') + ' ' + limit);
                event.target.value = newValue.substr(0, limit);
                return;
            }
        }
        if (props.onChange) {
            props.onChange(event);
        }
    }

    const Component = isTextAreaAutoSize ? TextareaAutosize : TextField

    function avoidNonStandardHtmlElements() {
        const finalProps = {...props};
        if (isTextAreaAutoSize) {
            delete finalProps.originalValue;
        }
        delete finalProps.isTextAreaAutoSize
        return finalProps;
    }

// avoid causing react errors of unknown props of the html element
    const finalProps = avoidNonStandardHtmlElements();
    if (!finalProps.FormHelperTextProps) {
        finalProps.FormHelperTextProps = {'data-testid': 'form-error-text'};
    }
    return (
        <Component
            {...finalProps}
            onChange={change}
        />
    )
})

LimitedTextField.propTypes = {
    limit: PropTypes.number,
    propertyValue: PropTypes.string,
    isTextAreaAutoSize: PropTypes.bool
}

export default LimitedTextField;

